import styled from 'styled-components';

export const StyledLabel = styled.label`
  width: ${(p) => p.theme.space[6]};
  height: ${(p) => p.theme.space[3]};
  position: relative;
  border-radius: ${(p) => p.theme.radii.pill};
`;

export const StyledSwitch = styled.div`
  background-color: ${(p) => p.theme.alias.subtle};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  border-radius: inherit;

  &::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: ${(p) => p.theme.space[2]};
    height: ${(p) => p.theme.space[2]};
    transition: transform 150ms ease-in-out;
    border-radius: inherit;
    background-color: ${(p) => p.theme.alias.bg};
  }
`;

export const StyledInput = styled.input`
  width: 0;
  height: 0;
  opacity: 0;

  &:checked + ${StyledSwitch} {
    background-color: ${(p) => p.theme.alias.primary};

    &::before {
      transform: translateX(16px);
    }
  }

  &:disabled + ${StyledSwitch} {
    background-color: ${(p) => p.theme.alias.shadow};
  }

  &:focus-visible + ${StyledSwitch} {
    box-shadow: ${(p) => p.theme.shadows.focusAlt};
  }
`;
